import { useState } from "react";
import TextInput from "../shared/textInput";
import api from '../../api/api';
import { useUser } from "../../context/UserContext";
import validation from "../../helpers/validation";
import Button from "../shared/button";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './users.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [input, setInput] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    //const [staySignedIn, setStaySignedIn] = useState(false);
    const { setUser } = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    const submit = async (event) => {
        if (event?.preventDefault) event.preventDefault();
        if (submitting) return;

        try {
            const normalizedEmail = email.trim().toLowerCase();

            if (!validation.validateEmail(normalizedEmail)) {
                setMessage({ type: 'error', text: 'Please enter a valid email address.' });
                return;
            }

            if (!input) {
                setMessage({ type: 'error', text: 'Please enter your password.' });
                return;
            }

            setSubmitting(true);
            const resp = await api.post('/user/login', { email: normalizedEmail, password: input });
            if (!resp?.data?.token) {
                setMessage({ type: 'error', text: 'Invalid login.' });
                return;
            }

            setUser(resp.data);
            //localStorage.setItem('token', resp.data.token);
            //if (staySignedIn) {
                localStorage.setItem('user', JSON.stringify(resp.data));
            //}
            setMessage({ type: '', text: '' });

            const requestedReturn = location?.state?.from;
            const requestedPath = String(requestedReturn?.pathname || '');
            const requestedDestination = requestedPath.startsWith('/') && !requestedPath.toLowerCase().startsWith('/login')
                ? `${requestedPath}${requestedReturn?.search || ''}${requestedReturn?.hash || ''}`
                : '';

            if (String(resp?.data?.role || '').toLowerCase() === 'cleaner') {
                navigate(requestedPath.toLowerCase() === '/cleanerdashboard' && requestedDestination ? requestedDestination : '/CleanerDashboard');
            } else if (String(resp?.data?.role || '').toLowerCase() === 'guest') {
                navigate(requestedPath.toLowerCase() === '/cleanerdashboard' && requestedDestination ? requestedDestination : '/');
            } else {
                const searchParams = new URLSearchParams(location.search || '');
                const inviteToken = String(searchParams.get('cohostInviteToken') || '').trim();
                const fromSearch = String(location?.state?.from?.search || '');
                const fromParams = new URLSearchParams(fromSearch);
                const stateInviteToken = String(fromParams.get('cohostInviteToken') || '').trim();
                const effectiveInviteToken = inviteToken || stateInviteToken;

                if (effectiveInviteToken) {
                    navigate(`/Properties?cohostInviteToken=${encodeURIComponent(effectiveInviteToken)}`);
                } else if (requestedDestination) {
                    navigate(requestedDestination);
                } else {
                    navigate('/Properties');
                }
            }
        } catch (e) {
            const backendError = e?.response?.data?.error;
            if (backendError === 'invalid') {
                setMessage({ type: 'error', text: 'Invalid login.' });
            } else {
                setMessage({ type: 'error', text: 'Unable to log in right now. Please try again.' });
            }
        } finally {
            setSubmitting(false);
        }
    };

    return <div className="auth-shell">
        {message.text && <div className={`app-notice auth-status ${message.type === 'success' ? 'app-notice-success' : 'app-notice-error'}`} aria-live="polite">{message.text}</div>}
        <div className="auth-card">
            <div className="auth-header">
                <h3>Welcome Back</h3>
                <p>Sign in to manage properties, direct bookings, and guest conversations from one place.</p>
            </div>

            <form className="auth-form" onSubmit={submit}>
                <div className="user-input-area auth-fields">
                    <label className="auth-label" htmlFor="login-email">Email</label>
                    <TextInput id="login-email" onChange={setEmail} value={email} type="email" placeholder={'you@email.com'} autoComplete="email" required />
                    <p className="auth-field-hint">Use the email address tied to your host or guest account.</p>

                    <label className="auth-label" htmlFor="login-password">Password</label>
                    <TextInput id="login-password" onChange={setInput} value={input} type="password" placeholder={'Enter your password'} autoComplete="current-password" required />
                    <p className="auth-field-hint">Press Enter from either field to sign in.</p>
                    <Link to="/forgot-password" className="auth-inline-link password-forgot-link">Forgot password?</Link>
                </div>

                <div className="auth-actions auth-actions-spread">
                    <div className="auth-footer-copy">
                        <span>Need an account?</span>
                        <Link to="/signup" className="auth-inline-link">Create one</Link>
                    </div>
                    <Button text={submitting ? 'Logging In...' : 'Log In'} type="submit" disabled={submitting} />
                </div>
            </form>
        </div>
       {/* <inputarea>
       <label for="persist">Stay signed in</label>
       <input type="checkbox" name="persist" id="persist" onChange={(e) => setStaySignedIn(e.target.checked)} />       
       </inputarea> */}
    </div>;
};

export default Login;